exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".platform-user-ui-permissions .el-tree-node__label{margin-left:5px}", "", {"version":3,"sources":["/workspace/src/views/platform-user/pages/PlatformUserUIPermissions.vue"],"names":[],"mappings":"AACA,mDAAmD,eAAe,CACjE","file":"PlatformUserUIPermissions.vue","sourcesContent":["\n.platform-user-ui-permissions .el-tree-node__label{margin-left:5px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-405df0d7","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/platform-user/pages/PlatformUserUIPermissions.vue
// module id = 5174
// module chunks = 72